import cx from 'helpers/cx'

import { DisplayDate } from 'js/components/DisplayDate'
import Img from 'js/components/Img/Img'
import styles from 'js/magazine/components/HeaderLogo/HeaderLogo.module.css'

type Icon = {
    download?: string
    url?: string
}

type HeaderLogoProps = {
    icon?: Icon | null
    title: string
    number?: string
    subtitle?: string
    date?: string
    isSmall?: boolean
    children?: React.ReactNode
}

const HeaderLogo = ({
    icon,
    title,
    number,
    subtitle,
    date,
    isSmall,
    children,
    ...rest
}: HeaderLogoProps) => (
    <div className={cx(styles.wrapper, isSmall && styles.isSmall)} {...rest}>
        <Img
            src={icon?.download}
            align="center"
            fullSize
            className={styles.icon}
        />
        <div>
            <div className={styles.titleContainer}>
                <h1 className={styles.title}>
                    {title}
                    {number && ` ${number}`}
                </h1>
                {children}
            </div>
            <h2 className={styles.subtitle}>
                {subtitle && <span>{subtitle}</span>}
                {date && <DisplayDate date={date} type="date" disableTooltip />}
            </h2>
        </div>
    </div>
)

export default HeaderLogo
